const FATHA = '\u064E';
const DAMMA = '\u064F';
const KASRA = '\u0650';
const SUKUN = '\u0652';

const removeNiqqud = (str) => (str || '').replace(/[\u064B-\u065F]/g, '');

export function buildParticiplesFromRoot(row) {
  if (!row) return null;
  
  const binyan = row['בניין'] || row['binyan'] || '';
  const gizra = row['gizra'] || '';
  
  if (String(binyan) !== '1' && binyan !== 'בניין 1') return null;
  if (!gizra.includes('שלמים')) return null;
  
  const rootStr = (row['שורש'] || row['root'] || '').trim();
  const cleanRoot = removeNiqqud(rootStr);
  const letters = cleanRoot.split('').filter(c => /[\u0621-\u064A]/.test(c));
  
  if (letters.length !== 3) {
    console.warn('Root does not have exactly 3 letters:', rootStr);
    return null;
  }
  
  const [r1, r2, r3] = letters;
  
  const activeM = `${r1}${FATHA}ا${r2}${KASRA}${r3}`;
  const activeFem = `${activeM}${FATHA}ة`;
  const activePlural = `${activeM}${DAMMA}ون${FATHA}`;
  
  const passiveM = `م${FATHA}${r1}${SUKUN}${r2}${DAMMA}و${r3}`;
  const passiveFem = `${passiveM}${FATHA}ة`;
  const passivePlural = `${passiveM}${DAMMA}ون${FATHA}`;
  
  return {
    active: {
      masculine: activeM,
      feminine: activeFem,
      plural: activePlural,
      pluralFeminine: `${activeM}${FATHA}ات`
    },
    passive: {
      masculine: passiveM,
      feminine: passiveFem,
      plural: passivePlural,
      pluralFeminine: `${passiveM}${FATHA}ات`
    },
    root: cleanRoot
  };
}

export function getAllParticipleForms(row) {
  const participles = buildParticiplesFromRoot(row);
  if (!participles) return [];
  
  return [
    { form: participles.active.masculine, type: 'active', gender: 'masculine', typeHeb: 'בינוני פועל', genderHeb: 'יחיד' },
    { form: participles.active.feminine, type: 'active', gender: 'feminine', typeHeb: 'בינוני פועל', genderHeb: 'יחידה' },
    { form: participles.active.plural, type: 'active', gender: 'plural', typeHeb: 'בינוני פועל', genderHeb: 'רבים' },
    { form: participles.active.pluralFeminine, type: 'active', gender: 'pluralFeminine', typeHeb: 'בינוני פועל', genderHeb: 'רבות' },
    { form: participles.passive.masculine, type: 'passive', gender: 'masculine', typeHeb: 'בינוני פעול', genderHeb: 'יחיד' },
    { form: participles.passive.feminine, type: 'passive', gender: 'feminine', typeHeb: 'בינוני פעול', genderHeb: 'יחידה' },
    { form: participles.passive.plural, type: 'passive', gender: 'plural', typeHeb: 'בינוני פעול', genderHeb: 'רבים' },
    { form: participles.passive.pluralFeminine, type: 'passive', gender: 'pluralFeminine', typeHeb: 'בינוני פעול', genderHeb: 'רבות' }
  ];
}

export { removeNiqqud };
